module.exports = __webpack_public_path__ + "img/numeric.3a69b7aa.png";